export default () => {
    if (typeof document === 'undefined') return null;
    const cookie = document.cookie
        .split('; ')
        .find((cookie) => cookie.startsWith('_tidst'));
    if (!cookie) {
        return null;
    }
    return cookie.replace(`${cookie.split('=')[0]}=`, '');
};
